import {AfterViewChecked, Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PoolsService } from '../../../../services/configuration/pools.service';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import {AdminService} from '../../../../services/admin.service';
import {EnumTranslateService} from '../../../../services/enumTranslate-service';
import {Utils} from '../../../../services/utils';
import {BusinessProcessService} from '../../../../services/business-process.service';
import {formatDate} from '@angular/common';
import {SystemFlowService} from '../../../../services/configuration/system-flow.service';

@Component({
  selector: 'app-pools-modal',
  templateUrl: './pools-modal.component.html',
  styleUrls: ['./pools-modal.component.css', '../../../../styles/modals.css']
})
export class PoolsModalComponent implements OnInit, AfterViewChecked {

  @ViewChild('poolTabs', { static: false }) poolTabs: TabsetComponent;
  errorMessage = '';
  successMessage = '';
  errorMetadataTabMessage = '';

  availableSystemFlows = [];
  availablePools = [];
  availableGroups = [];
  availableUsers = [];
  dmSelectedUsers: any[];
  selectedUsers = [];
  selectUserByOptions = [
    { value: 0, text: 'Todos os usuários do sistema' },
    { value: 2, text: 'Usuários no pool' },
    { value: 1, text: 'Usuários no grupo de usuários' }
  ];
  selectUserBy = 0;
  availableMetadatas = [];
  editMetadata = 0;
  editMetadataValues = '';
  invalidMetadataValues = '';
  isOnInit = true;

  objInitialState: any;
  poolId: number;
  poolsForm: FormGroup;
  filterForm: FormGroup;
  itemSaved: Subject<boolean> = new Subject();
  submitClick = false;
  hasConfigureAllMetadata = false;

  get formData() { return this.poolsForm.controls; }
  get filterData() { return this.filterForm.controls; }

  constructor(public bsModalRef: BsModalRef, private formBuilder: FormBuilder, private poolService: PoolsService,
              private adminService: AdminService, private bpService: BusinessProcessService,
              private systemFlowService: SystemFlowService) { }

  ngOnInit() {
    this.createForm();
    this.onSearchUsers();
    this.getAllSystemFlows();
    this.checkRight(33554432);

    if (this.objInitialState) {
      this.poolId = this.objInitialState.poolId;
      if (this.poolId > 0) {
        // realizar a busca por pool
        this.filterForm.patchValue({
          type: 2,
          poolId: this.poolId
        });
        this.onSearchUsers(true);
        this.getMetadataByPoolId();
      }
    }

  }

  ngAfterViewChecked() {
    const listItems = <HTMLCollectionOf<Element>>document.getElementsByClassName('ng-option');

    if (this.availableUsers) {
      this.changeColorData(listItems, this.availableUsers);
    }
  }

  changeColorData(listItems: HTMLCollectionOf<Element>, availableItems: any[]) {
    availableItems.forEach( item => {
      for (let i = 0 ; i < listItems.length ; i++ ) {
        if ( !item.enabled && item.toLabel === (<HTMLElement>listItems[i].children[0]).innerText )  {
          let itemChildren = <HTMLElement>listItems[i].children[0];
          itemChildren.style.color = '#ccc';
        }
      }
    });
  }

  createForm() {
    this.poolsForm = this.formBuilder.group({
      name: [ '', Validators.compose( [ Validators.required, Validators.maxLength(100) ])],
      description: [ '', Validators.maxLength(300) ],
      systemFlowId: 0
    });

    this.filterForm = this.formBuilder.group({
      type: 0,
      poolId: null,
      groupId: null
    });
  }

  getSelectedUsers(data) {
    this.selectedUsers = data;
  }

  getAllPools() {
    this.errorMessage = '';

    this.poolService.getAll().subscribe(result => {
      this.availablePools = result;
    }, error1 => {
      this.errorMessage = error1;
    });
  }

  getAllGroups() {
    this.errorMessage = '';
    this.adminService.loadGroupList().subscribe(result => {
      this.availableGroups = result;
    }, error1 => {
      this.errorMessage = error1;
    });
  }

  getAllSystemFlows() {
    this.errorMessage = '';
    this.systemFlowService.getAllSystemFlow().subscribe(list => {
      this.availableSystemFlows = list.sort((n1, n2) => {
        if (n1.name > n2.name) {
          return 1;
        }
        if (n1.name < n2.name) {
          return -1;
        }
        return 0;
      });
    }, error1 => {
      this.errorMessage = error1;
    });
  }

  getAllPoolMetadatas() {
    this.errorMetadataTabMessage = '';
    this.poolService.getAllPoolMetadataValue(this.poolId).subscribe(result => {
      this.availableMetadatas = result;
      result.forEach(item => {
        if (item.structure.type == 2) {
          for (let i = 0; i < item.values.length; i++) {
            item.values[i] = formatDate(item.values[i], 'dd/MM/yyyy', 'pt-BR');
          }
        } else if (item.structure.type == 4){
          for (let i = 0; i < item.values.length; i++) {
            item.values[i] = item.values[i].toString().replace(".",",");
          }
        }
      });
    }, error1 => {
      this.errorMetadataTabMessage = error1;
    });
  }

  getMetadataByPoolId() {
    this.errorMessage = '';
    this.poolService.getMetaflowsInfoByPoolId(this.poolId).subscribe(result => {
      this.poolsForm.patchValue({
        name: this.objInitialState.name,
        description: this.objInitialState.description,
        systemFlowId: result.length && result[0].flowId || 0
      });
    }, error1 => {
      this.errorMessage = error1;
    });
  }

  onChangeFilterOption(event) {
    if (event.target.value === '2') {
      this.filterForm.get('poolId').setValidators(Validators.required);
      if (this.availablePools && this.availablePools.length === 0) { this.getAllPools(); }
    } else {
      this.filterForm.get('poolId').clearValidators();
      this.filterForm.get('poolId').reset();
    }

    if (event.target.value === '1') {
      this.filterForm.get('groupId').setValidators(Validators.required);
      if (this.availableGroups && this.availableGroups.length === 0) { this.getAllGroups(); }
    } else {
      this.filterForm.get('groupId').clearValidators();
      this.filterForm.get('groupId').reset();
    }
  }

  onSearchUsers(isEditValue = false) {
    this.errorMessage = '';
    const params = this.filterForm.getRawValue();
    params.type = parseInt(params.type, 10);
    params.poolId = params.poolId === null ? 0 : parseFloat(params.poolId);
    params.groupId = params.groupId === null ? 0 : parseFloat(params.groupId);
    this.poolService.getUsersByPoolUserFilter(params).subscribe(result => {
      result.forEach(item => {
        item.toLabel = `${item.logon} (${ item.pools.map(m => m.name).join(', ') })`;
        item.toLabel = item.toLabel.replace(' ()', '');
      });
      if (params.type == 2 && isEditValue) { // by_pool
        this.dmSelectedUsers = this.selectedUsers = result.map(m => m.userId);
        // this.selectUserBy = 0;
        this.filterForm.reset();
        this.filterForm.get('type').setValue(0);
        this.filterForm.updateValueAndValidity();
      } else {
        this.availableUsers = result;
      }
    }, error1 => {
      let err = error1;
      if (error1.indexOf('401') !== -1) {
        err = 'Erro: Sessão expirada.';
      }
      this.errorMessage = err;
    });
  }

  onEditMetadata(metadataId) {
    this.editMetadata = metadataId;
    const metadata = this.availableMetadatas.filter(function (element, index) {
      return (element.structure.metadataStructureId === metadataId);
    });
    this.editMetadataValues = metadata[0].values.join('\n');
  }

  onCleanMetadataValues(metadataId) {
    const metadata = this.availableMetadatas.filter(function (element, index) {
      return (element.structure.metadataStructureId === metadataId);
    });

    metadata[0].values = [];
  }

  onSaveMetadataValues(metadataId) {
    this.editMetadata = 0;
    const metadata = this.availableMetadatas.filter(function (element, index) {
      return (element.structure.metadataStructureId === metadataId);
    });

    metadata[0].values = [];
    metadata[0].values = this.editMetadataValues.split('\n').filter(f => f !== '');

    this.editMetadataValues = '';
  }

  getNewMetadataValues(metadataId) {
    const metadata = this.availableMetadatas.filter(function (element, index) {
      return (element.structure.metadataStructureId === metadataId);
    });
    let values = [];
    if (metadata[0].values && metadata[0].values.length > 0) {
      values = metadata[0].values.join('; ');
    }
    return values;
  }

  validateMetadata(value, metadataType) {
    this.invalidMetadataValues = '';
    const invalidItems = [];
    const items = value.split('\n').filter(f => f !== '');
    items.forEach(item => {
      switch (metadataType) {
        case 1: /*integer*/
          if (isNaN(item)) { // se não for numero, já invalido
            invalidItems.push(item);
          } else {
            /*invalida se o resultado for diferente de zero, então não é numero inteiro ou
            se finalizar com ponto (ex.: 1. )*/
            if (item % 1 !== 0 || item.indexOf('.') > -1) {
              invalidItems.push(item);
            }
          }
          break;
        case 2: /*date*/
          let dayFormat = 'DD';
          let monthFormat = 'MM';
          const dateArray = item.split('/');
          if (dateArray.length !== 3) {
            invalidItems.push(item);
            break;
          } else {
            if (dateArray[0].length < 1 || dateArray[0].length > 2) {
              invalidItems.push(item);
              break;
            } else {
              dayFormat = 'D'.repeat(dateArray[0].length);
            }
            if (dateArray[1].length < 1 || dateArray[1].length > 2) {
              invalidItems.push(item);
              break;
            } else {
              monthFormat = 'M'.repeat(dateArray[1].length);
            }
          }

          if (!Utils.validateDate(item, `${dayFormat}/${monthFormat}/YYYY`)) {
            invalidItems.push(item);
          }

          break;
        case 3: /*text*/
          break;
        case 4: /*floating*/
          //if (isNaN(item)) { // se não for numero, já invalido
          if (!Utils.isBrNumeric(item)) { // se não for numero, já invalido
            invalidItems.push(item);
          }
          break;
      }
    });
    if (invalidItems.length > 0) {
      this.invalidMetadataValues =
        `Valores não conversíveis para o tipo ${EnumTranslateService.getEnumMetadataType(metadataType)}: ${ invalidItems.join(', ') }`;
    }
  }

  checkRight(item: number) {
    this.errorMessage = '';
    this.bpService.checkRights(item).subscribe(right => {
      this.isOnInit = false;
      switch (item) {
        case 33554432:
          this.hasConfigureAllMetadata = right.length > 0;
          if (this.hasConfigureAllMetadata) {
            this.getAllPoolMetadatas();
          }
          break;
      }
    }, error1 => {
      this.errorMessage = error1;
    });
  }

  onSave() {
    this.errorMessage = '';
    this.submitClick = true;
    const pools = this.poolsForm.getRawValue();
    const metadataValues =
      this.availableMetadatas
        .filter(f => f.values && f.values.length > 0)
        .map(obj => Utils.mapOut(obj, ['extensionData'])).slice();

    for (let i = 0; i < metadataValues.length; i++) {
      delete metadataValues[i]['structure'].extensionData;
      if (metadataValues[i]['structure'].type === 2) { // se for data, preciso tratar
        for (let j = 0; j < metadataValues[i]['values'].length; j++) {
          const dataArr = metadataValues[i]['values'][j].split('/');
          metadataValues[i]['values'][j] = `${dataArr[2]}-${dataArr[1]}-${dataArr[0]}T03:00Z`;
        }
      }
    }

    const saveBundle = {
      pool: { poolId: this.poolId, name: pools.name, description: pools.description },
      systemFlows: pools.systemFlowId !== 0 ? [ pools.systemFlowId ] : [],
      users: this.selectedUsers ? this.selectedUsers : [],
      metadataValues: metadataValues
    };

    this.poolService.save(saveBundle).subscribe(result => {
      let saveType = 'criado';
      if (this.poolId > 0) {
        saveType = 'atualizado';
      }
      this.successMessage = `Pool ${saveType} com sucesso.`;
      this.submitClick = false;
      setTimeout(() => {
        this.itemSaved.next(true);
        this.bsModalRef.hide();
      }, 2000);
    }, error1 => {
      this.submitClick = false;
      let err = error1;
      if (error1.indexOf('401') !== -1) {
        err = 'Erro: Sessão expirada.';
      }
      this.errorMessage = err;
    });
  }

  onClose() {
    this.itemSaved.next(false);
    this.bsModalRef.hide();
  }

  translateMetadataStructureType(type) {
    return EnumTranslateService.getEnumMetadataType(type);
  }
}
